import React from 'react';

export function Span({ children, className, id, onClick, ...rest }) {
    return <span id={id} className={className} onClick={onClick} {...rest}>
        {children}
    </span>
}